import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="absolute inset-0 mx-4 md:mx-6 my-4 rounded-2xl md:rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cityscape%20illustration%20with%20warm%20evening%20lighting%2C%20Seoul%20inspired%20urban%20skyline%2C%20cinematic%20color%20grading%20with%20olive%20green%20and%20amber%20tones%2C%20dreamy%20atmospheric%20perspective%2C%20soft%20bokeh%20effects%2C%20artistic%20illustration%20style%2C%20wide%20panoramic%20composition&width=1800&height=800&seq=cta-bg-comics&orientation=landscape"
          alt="韩漫大全 - 立即开始阅读"
          title="韩漫大全 - 开始阅读"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 px-4 md:px-6 flex flex-col lg:flex-row items-center justify-between gap-8 max-w-5xl mx-auto">
        <div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight">
            立即开始
            <br />
            免费阅读
          </h2>
          <p className="text-white/70 text-sm md:text-base mt-4 max-w-md">
            加入<strong>1,000万+</strong>读者，畅享海量韩漫资源。完全免费，无需注册即可阅读。
          </p>
        </div>

        <Link
          to="/category/all"
          className="shrink-0 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-950 font-semibold text-sm md:text-base hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          立即开始阅读
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950 text-background-50">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}